/**
 * 应用搭建增购项
 */
export enum VipAddOnKey {
    /** 应用数量 */
    app = 'app',
    /** 应用搭建 api */
    data_api = 'data_api'
}

/**
 * 会员服务类型
 */
export enum VipServiceType {
    // 基础服务
    basic = 'basic',
    // 银牌服务
    silver = 'silver',
    // 金牌服务
    gold = 'gold'
}

/**
 * 云币消费类型
 */
export enum COIN_CONSUMPTION_TYPE {
    SMS = 'sms',
    OCR = 'ocr',
    ATTACHMENT = 'attachment',
    BUSINESS_INFO = 'business_info',
    OPEN_PLUGIN = 'open_plugin',
    AUTOMATION = 'automation'
}
